/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faTiktok,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { sortBy } from 'lodash';

// HELPERS:
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: (theme as any).typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

export const CoverPhotoTooltip = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <HtmlTooltip title="Tooltip TODO" placement="top">
    {children as any}
  </HtmlTooltip>
);

export const instagramLabel = (
  <span>
    <Icon icon={faInstagram} /> Instagram
  </span>
);

export const tiktokLabel = (
  <span>
    <Icon icon={faTiktok} /> TikTok
  </span>
);

export const youtubeLabel = (
  <span>
    <Icon icon={faYoutube} /> YouTube
  </span>
);

const Title = ({ children }: { children: React.ReactNode }) => (
  <div className="text-base font-bold text-gray-500 leading-6 mb-4">
    {children}
  </div>
);

export function Label({
  title,
  required = false,
  children,
  className = '',
  error = '',
  Tooltip = undefined,
}: {
  title: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
  Tooltip?: any;
  error?: string;
}) {
  return (
    <div className={className}>
      <Title>
        {title}
        <span className="text-red-500">{required && ' *'} </span>
        {Boolean(Tooltip) && (
          <Tooltip>
            <span>
              <Icon icon={faInfoCircle} />
            </span>
          </Tooltip>
        )}
      </Title>
      <div>{children}</div>
      {error && <div className="text-red-500">{error}</div>}
    </div>
  );
}

export const PROFILE_KEYWORDS = sortBy([
  'Build muscle',
  'Weight loss',
  'Toning',
  'Shred fat',
  'Athletic',
  'Lean muscle',
  'Performance',
  '6-pack',
  'No equipment',
  'Bodyweight',
  'Home',
  'Beginner',
  'Mom',
  'Strength',
  'Conditioning',
  'Functional',
  'Mobility',
  'Flexibility',
  'Stretching',
  'Endurance',
  'Recovery',
  'Classes',
  'Crossfit',
  'Kettlebell',
  'Tabata',
  'Barre',
  'Pilates',
  'Yoga',
  'Boxing',
  'HIIT',
  'Cardio',
  'Pre/post natal',
  'Bikini Body',
  'Abs and Core',
  'Booty',
  'Full Body',
  'Celebrity',
  'Coaching',
  'Meditation',
  'Basketball',
  'Soccer',
  'Weight lifting',
]);
